









import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  PriceDto,
  PriceTypeDto
} from '@eurogast/hub-client-typescript';

@Component
export default class FairPriceIcon extends Vue {
  @Prop({ required: true })
  public currentPrice: PriceDto;

  get fairPriceIconUrl(): string {
    return '/images/fair_price/discount.svg';
  }

  get priceType(): PriceTypeDto {
    return this.currentPrice && this.currentPrice.type;
  }

  get isFairPrice(): boolean {
    return this.priceType === PriceTypeDto.FAIRLIST;
  }
}
